module.exports = __webpack_public_path__ + "img/btn-submit-en.7dfe9138.png";